import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function PrimaryCTA({ to, children, testId = "primary-cta", as = "link" }) {
  const cls = "inline-flex items-center gap-3 bg-ink text-ivory px-7 py-3.5 text-[11px] tracking-[0.24em] uppercase font-semibold hover:bg-brass transition-colors group";
  if (as === "anchor") {
    return (
      <a href={to} className={cls} data-testid={testId}>
        {children} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
      </a>
    );
  }
  return (
    <Link to={to} className={cls} data-testid={testId}>
      {children} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
    </Link>
  );
}

export function GhostCTA({ to, children, testId = "ghost-cta" }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2 text-ink border-b border-brass pb-1 hover:text-brass transition-colors text-[11px] tracking-[0.24em] uppercase font-semibold"
      data-testid={testId}
    >
      {children} <ArrowRight className="w-3 h-3" strokeWidth={2} />
    </Link>
  );
}

export function Eyebrow({ children, className = "" }) {
  return <p className={`eyebrow ${className}`}>{children}</p>;
}

export function SectionNum({ children, className = "" }) {
  return <span className={`section-num ${className}`}>{children}</span>;
}
